<template>
    <div>
        <ModalTitle :bodyStyle="{ 'padding': '0px 12px 30px 12px' }" :model-value="modelValue" :backdrop="backdrop"
            @update:model-value="onModelValue">
            <template #header>
                <div class="text-[24px] text-white font-[800] leading-[40px] tracking-[0.25px]">
                    {{ $t('niuniu.SelectRoom') }}</div>
            </template>

            <div>
                <ul class="flex flex-col gap-[8px]">
                    <li @click="select(item)" :class="item.selected ? 'tab-active' : ''"
                        class="flex justify-between items-center py-[12px] px-[10px] cursor-pointer"
                        v-for="(item, index) in hallsList" :key="index">
                        <div class="flex items-center gap-[6px]">
                            <img class="w-[24px] h-[24px]" :src="cow" alt="">
                            <span class="text-[14px] text-grey-40 font-[600] leading-[18px] tracking-[0.5px]">{{
                                locale == 'cn' ? item.nameCn : item.name }}</span>
                        </div>
                        <div class="text-[14px] text-grey-40 font-[700] leading-[18px]">{{ $t('niuniu.limit') }} {{
                            item.minBet }}-{{
                                item.maxBet }}</div>
                    </li>
                </ul>
            </div>
        </ModalTitle>

    </div>
</template>

<script setup lang="ts">
import { useNuxtApp } from '#app'
import cow from '../img/cow.png'
import { getHallsList, fnGoIntoOneHall } from '../ts/niuniuCommon';
import { useJoinStateStore } from '@/stores/cansino/joinState';

const { t: $tFn } = useNuxtApp().$i18n;
const showNoticeDialog = useNoticeDialog();

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    backdrop: {
        type: Boolean,
        default: true,
    },
})
const emit = defineEmits(['update:modelValue'])
const onModelValue = (value) => {
    emit('update:modelValue', value)
}
const route = useRoute()
const hallsList = ref([])

// 根据路由 id 参数确定倍数配置 (3 -> x3, 5 -> x5, 10 -> x10)
const routeId = route.params.id || '3' // 默认3倍
const multiplierKey = `x${routeId}` // x3, x5, x10

// 刷新房间列表数据的函数
const refreshHallsList = () => {

    // 获取原始数据
    const rawHallsList = getHallsList()

    // 重新整理数组：提取对应倍数的配置到顶层
    hallsList.value = rawHallsList.map(item => {
        const config = item[multiplierKey] || item.x3 // 如果找不到对应倍数配置，使用x3作为默认值
        return {
            name: item.name,
            nameCn: item.nameCn,
            enabled: item.enabled,
            rakeRate: item.rakeRate,
            minimumEntry: config.minimumEntry,
            minBet: config.minBet,
            maxBet: config.maxBet,
            accessable: item.accessable,
            betable: item.betable,
            selected: route.query.name === item.name,
            multiplier: routeId // 保存当前倍数
        }
    })

}

// 初始化时加载一次
refreshHallsList()

// 监听窗口打开状态，打开时重新请求数据
watch(() => props.modelValue, (newValue) => {
    if (newValue) {
        refreshHallsList()
    }
})


// 获取当前语言
const { locale } = useI18n();

const select = async (val) => {
    // 0. 如果点击的是当前房间，直接返回
    if (val.selected) {
        return;
    }

    // 1. 判断游戏是否进行中，如果是则弹出确认对话框
    const joinStateStore = useJoinStateStore();
    if (joinStateStore.gameRunning) {
        const oResolvers = Promise.withResolvers();
        // Dialog.create({
        //     title: $tFn('Note'),
        //     message: $tFn('exitGame.gameRunning'),
        //     persistent: true,
        //     style: { 'width': '300px' },
        //     transitionHide: 'none', // 关闭退场动画 
        //     ok: {
        //         label: $tFn('commonInfo.confirm'),
        //     },
        //     cancel: {
        //         label: $tFn('Cancel'),
        //     },
        // }).onOk(() => {
        //     oResolvers.resolve(true);
        // }).onCancel(() => {
        //     oResolvers.resolve(false);
        // });
        const result = await showNoticeDialog({
            title: $tFn('Note'),
            mainText: $tFn('exitGame.gameRunning'),
            mainTextStyle: 'font-size: 12px;font-weight: 600;line-height: 18px;',
            giftIcon: false,
            cancelButtonText: $tFn('exitGame.cancel'),
            buttonText: $tFn('exitGame.confirm'),
            themeStyle: 'border-color:#FF7F00;padding:15px 6px 11px 10px;border-width:1px;',
            dogImage: new URL('@/assets/imgs/orange-npc.webp', import.meta.url).href,           // 狗狗图片（可选）
            bgImage: new URL('@/assets/imgs/orange-bg.webp', import.meta.url).href,          // 背景图片（可选）
            oopsImage: new URL('@/assets/imgs/orange-oops.webp', import.meta.url).href,          // 浮动图片（可选）
        });
        if (result) {
            oResolvers.resolve(true);
        } else {
            oResolvers.resolve(false);
        }

        const answer = await oResolvers.promise;
        if (!answer) {
            return;
        }
    }

    // 2. 检查房间是否开启
    if (!val.enabled) {
        showNegativeNotify({
            i18n: 'goldenFlower.hallDisabled',
        });
        return;
    }
    // 3. 检查房间是否余额不足
    if (!val.accessable) {
        showNegativeNotify({
            i18n: 'niuniu.lowBalance',
        });
        return;
    }

    // 4. 关闭房间列表窗口
    onModelValue(false);
    // 5. 更新选中状态
    hallsList.value.forEach(item => {
        item.selected = item.name === val.name;
    });

    // 6. 显示成功进入房间的通知
    setTimeout(() => {
        showNegativeNotify({
            type: 'positive',
            position: 'top',
            timeout: 1500,
            message: $tFn('niuniu.enteredRoom', {
                room: locale.value === 'cn' ? val.nameCn : val.name
            }),
        });
    }, 100);

    // 7. 调用fnGoIntoOneHall方法切换房间（保持当前倍数）
    fnGoIntoOneHall(
        val,
        routeId, // 使用当前路由的倍数（3/5/10），保持倍数不变
        {
            query: { name: val.name },
            replace: true // 不生成浏览器页面历史
        }
    );
}
</script>
<style lang="scss" scoped>
.tab-active {
    border-radius: 8px;
    background: var(--color_grey-60);
}
</style>